import { useQuery } from "@apollo/client";
import { DEALER_LOCATOR_QUERY } from "../../Pregrine/ApplicationCenter/ApplicationCenter.gql";
import styles from "./ApplicationCenterPage.module.css";
import classNames from "classnames";
import LoadingIndicator from "../../components/LoadingIndicator";
import { Link } from "react-router-dom";

const ApplicationCenterPage = () => {
  const { data, loading, error } = useQuery(DEALER_LOCATOR_QUERY, {
    variables: { type: 2 },
  });

  return (
    <div>
      {!loading ? (
        data && data.getDealerList && data.getDealerList.length > 0 ? (
          <section
            className={classNames(
              styles["experience-centre"],
              "section-gap pt-5 pb-5"
            )}
          >
            <div className="container mt-2 ">
              <div className="row">
                {data.getDealerList.map((item, idx) => (
                  <div className="col-lg-3 mb-4" key={idx}>
                    <div className={styles.card}>
                      <h2>{item.name}</h2>
                      <Link
                        to={
                          item?.walkthrough_url
                            ? item?.walkthrough_url
                            : `https://maps.google.com/?q=${encodeURIComponent(
                                item?.address
                              )}`
                        }
                        target="_blank"
                        className={styles.location}
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16px"
                            height="16px"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill="#111111"
                              fillRule="evenodd"
                              d="M3.125 7a4.875 4.875 0 1 1 9.75 0c0 1.864-.774 2.962-1.687 3.815c-.385.36-.765.65-1.17.958l-.365.28a8.807 8.807 0 0 0-.781.668c-.243.24-.535.575-.73 1.01a.337.337 0 0 1-.095.132a.05.05 0 0 1-.015.008s-.01.004-.032.004s-.031-.003-.032-.003a.05.05 0 0 1-.015-.009a.337.337 0 0 1-.095-.131a3.385 3.385 0 0 0-.73-1.01a8.807 8.807 0 0 0-.781-.668c-.125-.097-.246-.19-.366-.28a14.78 14.78 0 0 1-1.169-.96C3.9 9.963 3.125 8.865 3.125 7M14.5 7c0 3.4-2.066 4.975-3.53 6.091c-.634.485-1.156.882-1.345 1.305C9.355 15 8.788 15.5 8 15.5s-1.354-.5-1.625-1.104c-.19-.423-.71-.82-1.346-1.305C3.566 11.975 1.5 10.399 1.5 7a6.5 6.5 0 0 1 13 0m-5 0a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M11 7a3 3 0 1 1-6 0a3 3 0 0 1 6 0"
                              clipRule="evenodd"
                            />
                          </svg>
                        </span>
                        <span
                          className={styles.addressValue}
                          dangerouslySetInnerHTML={{ __html: item.address }}
                        />
                      </Link>
                      <p className={styles.mobileWrapper}>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="#111111"
                              d="M3.833 4h4.49L9.77 7.618l-2.325 1.55A1 1 0 0 0 7 10c.003.094 0 .001 0 .001v.021a2.129 2.129 0 0 0 .006.134c.006.082.016.193.035.33c.039.27.114.642.26 1.08c.294.88.87 2.019 1.992 3.141c1.122 1.122 2.261 1.698 3.14 1.992c.439.146.81.22 1.082.26a4.424 4.424 0 0 0 .463.04l.013.001h.008s.112-.006.001 0a1 1 0 0 0 .894-.553l.67-1.34l4.436.74v4.32c-2.111.305-7.813.606-12.293-3.874C3.227 11.813 3.527 6.11 3.833 4m5.24 6.486l1.807-1.204a2 2 0 0 0 .747-2.407L10.18 3.257A2 2 0 0 0 8.323 2H3.781c-.909 0-1.764.631-1.913 1.617c-.34 2.242-.801 8.864 4.425 14.09c5.226 5.226 11.848 4.764 14.09 4.425c.986-.15 1.617-1.004 1.617-1.913v-4.372a2 2 0 0 0-1.671-1.973l-4.436-.739a2 2 0 0 0-2.118 1.078l-.346.693a4.71 4.71 0 0 1-.363-.105c-.62-.206-1.481-.63-2.359-1.508c-.878-.878-1.302-1.739-1.508-2.36a4.583 4.583 0 0 1-.125-.447z"
                            />
                          </svg>
                        </span>
                        <Link
                          to={`tel:${item.mobile}`}
                          className={styles.mobile}
                          rel="noopener noreferrer"
                        >
                          {item.mobile}
                        </Link>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        ) : (
          <p>No Data Found</p>
        )
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};

export default ApplicationCenterPage;
